import React, { useEffect, createElement } from 'react';
import { ProfitMaximizerUpsell } from '../components/ProfitMaximizerUpsell';
export function Modulo3Page() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1310">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1311">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1312">
          AI <span className="text-[#F5C842]" data-id="element-1313">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1314">
          <a href="/modulo-0" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1315">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1316">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1317">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1318">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1319">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1320">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] pb-[50px]" data-id="element-1321">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-1322">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1323">
            Módulo 3 de 4
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1324">
            ⏱ 20 minutos · Herramienta: Sales Letter Weapon
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1325">
          La Demo que
          <br data-id="element-1326" />
          <span className="text-[#F5C842]" data-id="element-1327">Cierra Sola</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1328">
          Cómo construir un sitio web profesional para tu prospecto en menos de
          10 minutos — antes de hablar con él. Cuando llegas con la demo lista,
          ya no eres un vendedor. Eres un consultor.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1329">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1330">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1331"></div>
            Herramienta: Sales Letter Weapon en HEYLLOYD
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1332">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1333"></div>
            Demo lista en menos de 2 minutos
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1334">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1335"></div>5 demos
            listas para presentar
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1336">
        {/* VIDEO */}
        <div className="mb-10" data-id="element-1337">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1338">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1339"></span>
            Video del Módulo
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1340">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1341">
              <iframe src="https://player.vimeo.com/video/1179701415?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 3" data-id="element-1342" />
            </div>
          </div>
        </div>

        {/* BUTTON MODULO 3 */}
        <div className="mt-4 mb-10" data-id="element-1343">
          <a href="https://app.heylloyd.io/share/lloyd/6f60b0db-b8a" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1344">
            <span className="text-[20px]" data-id="element-1345">📝</span>
            Abrir Sales Letter Weapon en Heylloyd
            <span className="text-[18px] font-black" data-id="element-1346">→</span>
          </a>
        </div>

        {/* STRATEGY BANNER */}
        <div className="mb-8 rounded-r-lg border border-[#2a2a2a] border-l-[4px] border-l-[#F5C842] bg-gradient-to-br from-[#0d0d0d] to-[#111] px-[28px] py-[24px]" data-id="element-1347">
          <div className="mb-2 font-heading text-[16px] font-black text-[#F5C842]" data-id="element-1348">
            ⚡ La Estrategia que Cambia Todo
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1349">
            La razón por la que la mayoría falla vendiendo servicios digitales
            es que llegan con palabras:{' '}
            <strong className="text-white" data-id="element-1350">
              "Te puedo hacer un sitio web."
            </strong>{' '}
            El cliente no lo ve. No lo cree. Y no compra.
            <br data-id="element-1351" />
            <br data-id="element-1352" />
            Con este módulo, llegas a la llamada con el sitio web del cliente{' '}
            <strong className="text-white" data-id="element-1353">ya construido</strong>. El cliente lo
            ve, le gusta, y la venta se cierra sola. Tú no convences — tú
            muestras.
          </div>
        </div>

        {/* TOOL HIGHLIGHT */}
        <div className="mb-8 flex flex-col md:flex-row gap-6 items-start rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black p-7" data-id="element-1354">
          <div className="text-[48px] leading-none shrink-0" data-id="element-1355">🧠</div>
          <div data-id="element-1356">
            <div className="mb-1.5 text-[8px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1357">
              Heylloyd — Cerebro de IA
            </div>
            <div className="mb-2 font-heading text-[24px] font-black text-white" data-id="element-1358">
              Sales Letter Weapon
            </div>
            <div className="max-w-[700px] text-[13px] leading-[1.7] text-[#888]" data-id="element-1359">
              La IA que construye el sitio web del cliente en minutos. Le das la
              información básica del negocio y ella genera una página
              profesional completa, lista para presentar como demo antes de la
              llamada de venta.
            </div>
          </div>
        </div>

        {/* DEMO STEPS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1360">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1361"></span>
          Cómo Construir una Demo en 5 Pasos
        </div>
        <div className="mb-8 flex flex-col gap-3" data-id="element-1362">
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1363">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1364">
              1
            </div>
            <div data-id="element-1365">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1366">
                Abre Sales Letter Weapon en HEYLLOYD
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1367">
                Selecciona el cerebro "Sales Letter Weapon" desde tu panel de
                HEYLLOYD
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1368">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1369">
              2
            </div>
            <div data-id="element-1370">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1371">
                Ingresa el nombre del negocio
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1372">
                El nombre exacto del negocio que encontraste en el Módulo 2 con
                Ai Website Arbitrage
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1373">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1374">
              3
            </div>
            <div data-id="element-1375">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1376">
                Ingresa tipo de negocio, ciudad y servicios
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1377">
                Toda esta información ya la tienes de tu lista de prospectos del
                Módulo 2
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1378">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1379">
              4
            </div>
            <div data-id="element-1380">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1381">
                Ingresa el número de teléfono del negocio
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1382">
                La IA lo incluirá en la sección de contacto del sitio generado
              </div>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-lg border border-[#1e1e1e] bg-[#111] px-5 py-4" data-id="element-1383">
            <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[13px] font-black text-black" data-id="element-1384">
              5
            </div>
            <div data-id="element-1385">
              <div className="mb-1 text-[13px] font-bold text-white" data-id="element-1386">
                Copia y guarda el link de la demo
              </div>
              <div className="text-[12px] leading-[1.5] text-[#777]" data-id="element-1387">
                En menos de 2 minutos tendrás una página profesional lista para
                enviar al cliente
              </div>
            </div>
          </div>
        </div>

        {/* WHAT IT GENERATES */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1388">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1389"></span>
          Qué Genera Sales Letter Weapon Automáticamente
        </div>
        <div className="mb-8 grid grid-cols-2 gap-3 md:grid-cols-5" data-id="element-1390">
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1391">
            <div className="mb-2 text-[24px]" data-id="element-1392">🎨</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1393">
              Logo del negocio
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1394">
            <div className="mb-2 text-[24px]" data-id="element-1395">📝</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1396">
              Descripción de servicios
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1397">
            <div className="mb-2 text-[24px]" data-id="element-1398">🖼️</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1399">
              Galería de fotos
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1400">
            <div className="mb-2 text-[24px]" data-id="element-1401">📍</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1402">
              Sección de contacto y mapa
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] px-3 py-4 text-center" data-id="element-1403">
            <div className="mb-2 text-[24px]" data-id="element-1404">📱</div>
            <div className="text-[11px] font-bold leading-[1.3] text-white" data-id="element-1405">
              Diseño responsive móvil
            </div>
          </div>
        </div>

        {/* INFO NEEDED */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1406">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1407">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1408">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1409"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1410">
                Información que necesitas del negocio
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1411">
              <ul className="flex flex-col" data-id="element-1412">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1413">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1414">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1415">Nombre del negocio</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1416">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1417">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1418">Tipo de negocio</strong>{' '}
                  (restaurante, peluquería, etc.)
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1419">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1420">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1421">Ciudad y dirección</strong>
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1422">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1423">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1424">Servicios que ofrece</strong>
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1425">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1426">
                    →
                  </span>
                  <strong className="text-white" data-id="element-1427">Número de teléfono</strong>
                </li>
              </ul>
              <br data-id="element-1428" />
              <em className="text-[11px] text-[#555]" data-id="element-1429">
                ✓ Todo esto lo encontraste en el Módulo 2 con Ai Website
                Arbitrage
              </em>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1430">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1431">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1432"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1433">
                ¿Tiene que ser perfecta la demo?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1434">
              <strong className="text-white" data-id="element-1435">No.</strong> No tiene que ser
              perfecta. Tiene que ser{' '}
              <strong className="text-white" data-id="element-1436">
                profesional y mucho mejor que lo que tienen ahora
              </strong>
              . Eso es todo lo que necesitas para cerrar la venta.
              <br data-id="element-1437" />
              <br data-id="element-1438" />
              Cuando el cliente ve su negocio representado de forma profesional
              en pantalla, la conversación cambia completamente. Ya no estás
              vendiendo — estás{' '}
              <strong className="text-white" data-id="element-1439">
                mostrando el resultado final
              </strong>
              .
            </div>
          </div>
        </div>

        {/* SCRIPT */}
        <div className="mb-8" data-id="element-1440">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1441">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1442"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-1443">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1444">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1445"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1446">
              "Módulo 3. Este es el módulo que más me emociona enseñarte. Voy a
              mostrarte cómo construir un sitio web profesional para tu
              prospecto en menos de 10 minutos, antes de hablar con él. Cuando
              llegues a la llamada con una demo ya lista, la conversación cambia
              completamente. Ya no eres un vendedor. Eres un consultor que ya
              hizo el trabajo."
            </div>
          </div>

          <div className="mb-4" data-id="element-1447">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1448">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1449"></span>⏱
              0:30 – 15:00 · Demo en Pantalla
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1450">
              "Abre el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1451">
                'Sales Letter Weapon'
              </span>{' '}
              en HEYLLOYD. Vas a ver que te pide información básica del negocio:
              nombre, tipo de negocio, ciudad, servicios que ofrece y número de
              teléfono. Toda esa información la encontraste en el Módulo 2 con
              el cerebro{' '}
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1452">
                'Ai Website Arbitrage'
              </span>
              ."{'\n\n'}
              "Rellena los campos con la información de tu primer prospecto.
              Ahora observa. En menos de 2 minutos, el cerebro genera una página
              web completa con: el logo del negocio, una descripción de sus
              servicios, una galería de fotos, y una sección de contacto con su
              teléfono y mapa."{'\n\n'}
              "¿Es perfecta? No. ¿Es profesional y mucho mejor que lo que tienen
              ahora? Absolutamente. Y eso es todo lo que necesitas para cerrar
              la venta."{'\n\n'}
              "Guarda el link de la demo. En el Módulo 4, te voy a enseñar
              exactamente qué decir cuando llames a este negocio."
            </div>
          </div>

          <div className="mb-4" data-id="element-1453">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1454">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1455"></span>⏱
              15:00 – 20:00 · Cierre y Tarea
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1456">
              "Tarea: construye una demo para cada uno de tus 5 prospectos.
              Guarda el link de cada una. Cuando tengas las 5 demos listas,
              estás listo para el Módulo 4 y para hacer tu primera venta."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-1457">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-1458">
            ✅ Tu Tarea — Módulo 3
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1459">
            Usa <strong className="text-white" data-id="element-1460">Sales Letter Weapon</strong> en
            HEYLLOYD y construye una demo para cada uno de tus{' '}
            <strong className="text-white" data-id="element-1461">5 prospectos</strong>. No hagas
            ninguna llamada sin tener la demo lista primero.
            <div className="mt-3 flex flex-col gap-2" data-id="element-1462">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1463">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1464">
                  1
                </div>
                Abre HEYLLOYD y selecciona el cerebro "Sales Letter Weapon"
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1465">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1466">
                  2
                </div>
                Ingresa la información del Prospecto #1 (nombre, tipo, ciudad,
                servicios, teléfono)
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1467">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1468">
                  3
                </div>
                Copia y guarda el link de la demo generada
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1469">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1470">
                  4
                </div>
                Repite para los 5 prospectos de tu lista
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1471">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1472">
                  5
                </div>
                <strong className="text-white" data-id="element-1473">
                  Cuando tengas las 5 demos listas, pasa al Módulo 4
                </strong>
              </div>
            </div>
          </div>
        </div>

        {/* PROFIT MAXIMIZER UPSELL */}
        <ProfitMaximizerUpsell data-id="element-1474" />
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-1475">
        <a href="/modulo-2" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] no-underline transition-colors hover:text-white" data-id="element-1476">
          ← Módulo 2
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-1477">
          AI <span className="text-[#F5C842]" data-id="element-1478">WEB CLOSER</span>
        </div>
        <a href="/modulo-4" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-1479">
          Módulo 4: El Cierre Sin Presión →
        </a>
      </div>
    </div>;
}